
import Vue from "vue";
import { FrontendFuncParam } from "@/models/frontend-func-param";
import { FrontendFunc } from "@/models/frontend-func";

export default Vue.extend({
	props: {
		params: {
			type: Array as ()=>FrontendFuncParam[],
			required: true
		}
	},
	computed: {
		valid():boolean {
			for (let param of this.params){
				if (!this.isParamNameValid(param.Name)){
					return false;
				}
			}
			return true;
		}
	},
	watch: {
		valid: {
			immediate: true,
			handler(){
				this.$emit("valid", this.valid);
			}
		}
	},
	methods: {
		removeParam(i:number){
			this.params.splice(i,1);
		},
		addParam(){
			let param = new FrontendFuncParam();
			this.params.push(param);
		},
		isParamNameValid(paramName:string):boolean{
			if (!FrontendFunc.validNameRegex.test(paramName)){
				return false;
			}
			let occurance = 0;
			for (let f of this.params){
				if (f.Name == paramName) {
					occurance++;
				}
			}
			if (occurance>1){
				return false;
			}
			return true;
		}
	}
});
